import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.Galleries = routerStyxie({ actions: ['show']})
